<template>
  <div class="profil-container">
    <h3 class="profil-title">
      Selamat Datang di Halaman Pendaftaran dan Pembaruan Informasi Sinarmas
      Mining
    </h3>
    <div class="instruction-wrapper">
      <div class="instruction-list">
        <div class="instruction-number">1.</div>
        <div class="instruction-text">
          Mohon untuk mengisi data selengkap mungkin demi mempermudah untuk
          lolos sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">2.</div>
        <div class="instruction-text">
          Anda wajib mengisi pertanyaan yang bertanda (<span class="text-ast"
            >*</span
          >)
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">3.</div>
        <div class="instruction-text">
          Sesuai dengan Undang-Undang 11 tahun 2020 tentang Cipta Kerja dan
          peraturan KKPM nomor 3 tahun 2021 tentang sistem perizinan berusaha
          berbasis risiko terintegrasi secara elektronik maka dari itu badan
          usaha wajib memiliki NIB untuk pendaftaran sebagai calon vendor
        </div>
      </div>
      <div class="instruction-list">
        <div class="instruction-number">4.</div>
        <div class="instruction-text">
          Jika memerlukan bantuan atau penjelasan tentang persyaratan tertentu,
          silahkan hubungi Dept.SIPM
        </div>
      </div>
    </div>

    <div class="profil-btn-wrapper">
      <div @click="goProfile()" class="btn-landing">Selanjutnya</div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    goProfile() {
      this.$store.commit('landingpage/SET_LANDINGPAGE_FORM', 'profilebu')
      this.$store.commit('landingpage/SET_STATE_DATA', {
        name: 'profil_step',
        value: true,
      })
    },
  },
}
</script>
